import { RliSdk, Widget } from '@rocketlane/rli-internal-sdk';
import { useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { ExpenseEventsMap } from 'events/expenses';
import { ProjectEventsMap } from 'events/projects';
import { ResourceRequestEventsMap } from 'events/resource-request';
import { TaskEventsMap } from 'events/tasks';
import { LDS_URL } from 'marketplace/api/lds-http-client';
import { useGetMarketplaceAuthToken } from 'marketplace/hooks/use-marketplace-hooks';
import { useWidgetCommunicationHandler } from 'marketplace/hooks/use-widget-communication-handler';
import { floatUidString } from 'utils/uid';

export const IframeWrapper = styled.div<{
  height?: string;
  width?: string;
}>`
  display: none;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

export const AddLdsScripts = () => {
  const { registerCallbacks, invokeServerMethodLocal, show } =
    useWidgetCommunicationHandler(-1, {
      isCustomerPortal: false,
      isLds: true,
    });
  const iframeRef = useRef<Widget | null>(null);

  const iframeId = useMemo(() => floatUidString(), []);
  const { data: marketplaceAuthToken } = useGetMarketplaceAuthToken();

  useEffect(() => {
    if (iframeRef.current === null && marketplaceAuthToken?.token) {
      RliSdk?.registerWidget({
        appId: 1,
        apiKey: marketplaceAuthToken?.token,
        baseUrl: LDS_URL,
        id: 'lds-client-events',
        src: `${LDS_URL}/client-events`,
        widgetIdentifier: 'lds-client-events',
        events: {
          ...TaskEventsMap,
          ...ProjectEventsMap,
          ...ExpenseEventsMap,
          ...ResourceRequestEventsMap,
        },
        data: {
          GET_USER_DATA: 'user',
          // GET_USER_PROJECTS: 'user_projects',
          GET_USER_ACCOUNT: 'account',
        },
        parent: document.getElementById('lds-client-events') as HTMLElement,
      }).then((widget) => {
        iframeRef.current = widget as Widget;
        registerCallbacks(widget as Widget);
      });
    }

    return () => {
      if (iframeRef.current) {
        RliSdk?.deRegisterWidget?.(iframeRef.current?.id);
        iframeRef.current = null;
      }
    };
  }, [
    iframeId,
    invokeServerMethodLocal,
    registerCallbacks,
    show,
    marketplaceAuthToken?.token,
  ]);

  return <IframeWrapper id="lds-client-events" />;
};
